import React, { FC } from "react";

import {
  activeBusinessFiltersState,
  createBasketBusinessFilter,
  DataViewKey,
  useDataView,
} from "@keepeek/commons";
import { withSuspense } from "@keepeek/refront-components";
import { Box } from "@mui/material";
import clsx from "clsx";
import { useRecoilValue } from "recoil";

import { currentBasketIdState } from "../../providers/basket/atoms";
import { useAttachmentsDownloadManager } from "../../providers/downloadManager/hooks/attachments";
import AttachmentsByElement from "./AttachmentsByElement";

export type DownloadManagerAttachmentsElementListsProps = { dataViewKey: DataViewKey };

const DownloadManagerAttachmentsElementLists: FC<
  React.PropsWithChildren<DownloadManagerAttachmentsElementListsProps>
> = function ({ dataViewKey }) {
  const { attachmentsByElements } = useAttachmentsDownloadManager();
  const filters = useRecoilValue(activeBusinessFiltersState(dataViewKey));
  const isSideBarBasketContext = dataViewKey === DataViewKey.BASKET;
  const currentBasketId = useRecoilValue(currentBasketIdState);
  const basketFilters = currentBasketId ? [createBasketBusinessFilter(currentBasketId)] : [];
  const { elements } = useDataView({
    key: dataViewKey,
    filters: isSideBarBasketContext ? basketFilters : filters || null,
  });

  return (
    <Box
      className={clsx("DownloadManagerElementLists")}
      component="ul"
      sx={{
        listStyle: "none",
        padding: 0,
        margin: (theme) => theme.spacing(2, 0),
      }}
    >
      {attachmentsByElements.map((attachmentsByElement) => (
        <AttachmentsByElement
          key={attachmentsByElement.elementId}
          attachmentsByElement={attachmentsByElement}
          elements={elements}
          dataViewKey={dataViewKey}
        />
      ))}
    </Box>
  );
};

export default withSuspense(DownloadManagerAttachmentsElementLists);
